import styled from '@emotion/styled'

export const Container = styled.div`
  align-items: center;
  background-color: #f7f7f7;
  justify-content: center;
  display: flex;
  padding: 2rem 0;
  width: 100%;
`
